<template>
  <div class="pagination">
    <button class="btn_page" @click="goToPage(localCurrentPage - 1)" :disabled="localCurrentPage === 1">
      <el-icon>
        <ArrowLeft/>
      </el-icon>
    </button>
    <span>{{ localCurrentPage }} / {{ totalPages }}</span>
    <button class="btn_page" @click="goToPage(localCurrentPage + 1)" :disabled="localCurrentPage === totalPages">
      <el-icon>
        <ArrowRight/>
      </el-icon>
    </button>
  </div>
</template>

<script setup>
import {computed, ref, watch} from "vue";
import {useStore} from "vuex";
import {ArrowLeft, ArrowRight} from "@element-plus/icons-vue";

const emit = defineEmits(["update-page"]);
const store = useStore();

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  currentPage: {
    type: Number,
    default: 1
  },
  type: {
    type: Number,
    default: 1,
  }
});

const localCurrentPage = ref(props.currentPage);
const totalPages = computed(() => props.item.childCount + 1);

watch(
    () => props.currentPage,
    (newPage) => {
      localCurrentPage.value = newPage;
    }
);

const goToPage = async (page) => {
  if (page < 1 || page > totalPages.value) return;

  localCurrentPage.value = page;
  emit("update-page", props.item.id, page);

  if (page === 1) {
    const res = JSON.parse(localStorage.getItem("pageData")) || [];
    const target = res.find(it => it.id === props.item.id);
    if (target) {
      props.item.content = target.content;
      props.item.associateContent = target.associateContent.split("\n\n").join("\n\n>");
    }
  } else {
    const res = JSON.parse(localStorage.getItem("pageData")) || [];
    if (!res.some(it => it.id === props.item.id)) {
      localStorage.setItem("pageData", JSON.stringify([...res, props.item]));
    }
    const typeMap = {
      1: {
        setCurrentPage: "AI/setCurrentPage",
        setPageNo: "AI/setChatDetailListSettingParent",
        getList: "AI/getChatDetailListApisParent",
        listKey: "chatDetailListParent",
      },
      default: {
        setCurrentPage: "AI/setCurrentPageMail",
        setPageNo: "AI/setChatDetailListSettingParentMail",
        getList: "AI/getChatDetailListApisParentMail",
        listKey: "chatDetailListParentMail",
      },
    };

    const config = typeMap[props.type] || typeMap.default;

// commit 是同步的，不需要 await
    store.commit(config.setCurrentPage, page);
    store.commit(config.setPageNo, {
      type: "pageNo",
      value: page - 1,
    });

// 只有 dispatch 才需要 await
    await store.dispatch(config.getList, {
      parentId: props.item.id,
    });

    const list = store.state.AI[config.listKey] || [];
    const firstItem = list[0];

    if (firstItem) {
      props.item.content = firstItem.content;
      props.item.associateContent = firstItem.associateContent
          ?.split("\n\n")
          .join("\n\n>");
    }
  }
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination button {
  padding: 5px 10px;
  font-size: 16px;
  cursor: pointer;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.pagination span {
  margin: 0 10px;
  font-size: 16px;
}

.btn_page {
  display: flex;
  align-items: center;
  padding: 0 !important;
  background: transparent !important;
  border: 1px solid transparent !important;
}
</style>